export enum FormulaGroupEnum {
    None = 0x00,
    BasicOperations = 0x01,
    Functions = 0x02,
    Comparisons = 0x04,
    Binary = 0x08,
    All = BasicOperations | Functions | Comparisons | Binary
}
